import { render, staticRenderFns } from "./form-dropdown.vue?vue&type=template&id=36825ece&scoped=true"
import script from "./form-dropdown.vue?vue&type=script&lang=js"
export * from "./form-dropdown.vue?vue&type=script&lang=js"
import style0 from "./form-dropdown.vue?vue&type=style&index=0&id=36825ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36825ece",
  null
  
)

export default component.exports